import { render } from "./BurgerBtn.vue?vue&type=template&id=665f70bb&scoped=true"
import script from "./BurgerBtn.vue?vue&type=script&lang=js"
export * from "./BurgerBtn.vue?vue&type=script&lang=js"

import "./BurgerBtn.vue?vue&type=style&index=0&id=665f70bb&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665f70bb"]])

export default __exports__